export const messages = {
    "wr-dashboard.search.input.hint": "Pesquisa",
    "wr-dashboard.search.label.breadcrumb": "Resultados da busca",
    "wr-dashboard.search.message.empty": "Nenhum item corresponde à sua pesquisa",
    "wr-dashboard.side-bar.selected.title:plural": "{count} itens selecionados | {count} item selecionado | {count} itens selecionados",
    "wr-dashboard.side-bar.backup-type.disk": "Disco",
    "wr-dashboard.side-bar.backup-type.file": "Arquivo",
    "wr-dashboard.side-bar.backup-type.notarized": "Arquivos e pastas notarizadas",
    "wr-dashboard.side-bar.backup-type.exchange": "Aplicativo – Microsoft Exchange",
    "wr-dashboard.side-bar.backup-type.sql": "Aplicativo – Microsoft SQL",
    "wr-dashboard.side-bar.backup-type.sys-state": "Aplicativo – Estado do sistema",
    "wr-dashboard.side-bar.backup-type.application": "Aplicativo",
    "wr-dashboard.backups-table.column.name": "Nome",
    "wr-dashboard.backups-table.column.size": "Tamanho",
    "wr-dashboard.backups-table.column.version": "Última versão",
    "wr-dashboard.backups-table.action.delete": "Excluir",
    "wr-dashboard.backups-table.message.no-backups": "Ainda não há backups na nuvem",
    "wr-dashboard.backups-sidebar.label.size": "Tamanho",
    "wr-dashboard.backups-sidebar.label.type": "Tipo",
    "wr-dashboard.backups-sidebar.label.version": "Última versão",
    "wr-dashboard.backups-sidebar.label.created": "Criado em:",
    "wr-dashboard.backups-sidebar.label.machine": "Máquina",
    "wr-dashboard.backups-sidebar.label.owner": "Proprietário",
    "wr-dashboard.content-table.column.name": "Nome",
    "wr-dashboard.content-table.column.versions": "Versões",
    "wr-dashboard.content-table.column.volumes": "Volumes",
    "wr-dashboard.content-table.column.path": "Caminho",
    "wr-dashboard.content-table.column.size": "Tamanho",
    "wr-dashboard.content-table.column.version": "Última versão",
    "wr-dashboard.content-table.action.notary-verify": "Verificar",
    "wr-dashboard.content-table.action.notary-get-crt": "Solicitar certificado",
    "wr-dashboard.content-table.action.asign": "Enviar para assinatura",
    "wr-dashboard.content-table.action.versions": "Versões",
    "wr-dashboard.content-table.action.restore": "Baixar",
    "wr-dashboard.content-table.label.size": "Tamanho",
    "wr-dashboard.content-table.label.created": "Criado em:",
    "wr-dashboard.content-table.label.modified": "Modificado",
    "wr-dashboard.content-table.message.empty-folder": "Esta pasta está vazia",
    "wr-dashboard.password-dialog-box.title.backup": "Backup criptografado",
    "wr-dashboard.password-dialog-box.title.archive": "Arquivo criptografado",
    "wr-dashboard.password-dialog-box.message.backup": "Especifique a senha para acessar o backup {displayName}",
    "wr-dashboard.password-dialog-box.message.archive": "Especifique a senha para acessar o arquivo {displayName}",
    "wr-dashboard.password-dialog-box.hint.password": "Senha",
    "wr-dashboard.password-dialog-box.message.invalid-password": "A senha está incorreta",
    "wr-dashboard.form.button.open": "Abrir",
    "wr-dashboard.form.button.close": "Fechar",
    "wr-dashboard.form.button.cancel": "Cancelar",
    "wr-dashboard.form.button.continue": "Continuar",
    "wr-dashboard.form.button.proceed": "Prosseguir",
    "wr-dashboard.form.button.delete": "Excluir",
    "wr-dashboard.form.button.done": "Feito",
    "wr-dashboard.form.button.retry": "Tentar novamente",
    "wr-dashboard.notary.verify.view.status.downloading": "Baixando...",
    "wr-dashboard.notary.verify.view.status.validating": "Validando...",
    "wr-dashboard.notary.verify.view.status.pending": "Certificado pendente...",
    "wr-dashboard.notary.verify.view.status.fail": "Não correspondência de certificado",
    "wr-dashboard.notary.verify.view.button.get-crt": "Solicitar certificado",
    "wr-dashboard.notary.verify.view.file-info.name": "NOME",
    "wr-dashboard.notary.verify.view.file-info.signed-by": "ASSINADO POR:",
    "wr-dashboard.notary.verify.view.file-info.date-backed-up": "DATA DO BACKUP",
    "wr-dashboard.notary.verify.view.file-info.date-notarized": "DATA DA NOTARIZAÇÃO",
    "wr-dashboard.notary.verify.view.button.cancel": "Cancelar",
    "wr-dashboard.notary.verify.view.button.done": "Feito",
    "wr-dashboard.notary.warning.unsupported.browser.version": "Versão de navegador incompatível",
    "wr-dashboard.versions-dialog-box.title": "Versões de {fileName}",
    "wr-dashboard.asign-dialog-box.title": "Enviar para assinatura",
    "wr-dashboard.asign-dialog-box.message": "A versão do arquivo é compartilhada, mas ninguém consegue ver o arquivo sem o link para o mesmo. Prossiga para o ASign para adicionar as assinaturas e compartilhar o link.",
    "wr-dashboard.asign-dialog-box.button.show-signed-file-details": "Mostrar detalhes do arquivo",
    "wr-dashboard.page-not-found.title": "Página não encontrada",
    "wr-dashboard.page-not-found.message.main": "A página que você está tentando acessar não foi encontrada.",
    "wr-dashboard.page-not-found.message.description": "O link pode ter expirado ou você pode ter digitado o endereço incorretamente.",
    "wr-dashboard.page-not-found.message.error": "Código de erro: 404",
    "wr-dashboard.server-error.title": "O servidor não está disponível",
    "wr-dashboard.server-error.message": "O servidor não está disponível no momento. Tente novamente mais tarde.",
    "wr-dashboard.server-error.message.error": "Código de erro: 500",
    "wr-dashboard.account-menu.action.sign-out": "Sair",
    "wr-dashboard.breadcrumb.item.machines": "Máquinas",
    "wr-dashboard.breadcrumb.item.failed-backups": "Backups com falha",
    "wr-dashboard.machines-table.column.name": "Nome",
    "wr-dashboard.machines-table.column.size": "Tamanho",
    "wr-dashboard.machines-table.message.no-machines": "Ainda não há máquinas na Nuvem",
    "wr-dashboard.incomplete-backups.message.status:plural": "Há {count} backups com falha ou incompletos ocupando {size} de armazenamento | Há {count} backup com falha ou incompleto ocupando {size} de armazenamento | Há {count} backups com falha ou incompletos ocupando {size} de armazenamento",
    "wr-dashboard.incomplete-backups.button.view": "Exibir backups",
    "wr-dashboard.incomplete-backups.button.delete": "Excluir backups",
    "wr-dashboard.machines-table.message.space-used:plural": "Utilização total de backup {size}",
    "wr-dashboard.delete-archive-dialog-box.title": "Excluir arquivos",
    "wr-dashboard.delete-incomplete-archive-dialog-box.title": "Excluir arquivos incompletos",
    "wr-dashboard.delete-all-incomplete-archives-dialog-box.title": "Excluir todos os arquivos incompletos",
    "wr-dashboard.delete-archive.message": "Tem certeza de que deseja excluir permanentemente os arquivos selecionados de todos os locais? Todos os dados serão excluídos e não poderão ser restaurados.",
    "wr-dashboard.delete-archive.deletion-warning-message": "Quaisquer alterações feitas neste console de restauração da Web podem não ser refletidas visualmente na respectiva carga de trabalho do console de proteção caso essa carga de trabalho não esteja online ou não haja algum agente online para processar as alterações",
    "wr-dashboard.delete-archive.locked-error-message": "O arquivo foi bloqueado para garantir a consistência dos dados. Encerre todas as operações com o arquivo (por exemplo, navegação, restauração, execução de backup) e tente novamente.",
    "wr-dashboard.certificate-pending-dialog-box.title": "Certificado pendente",
    "wr-dashboard.certificate-pending-dialog-box.message": "Tente novamente em alguns minutos.",
    "wr-dashboard.form.button.ok": "Ok"
};
